"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointTransformationSimulateIn = void 0;
class EndpointTransformationSimulateIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointTransformationSimulateIn.attributeTypeMap;
    }
}
exports.EndpointTransformationSimulateIn = EndpointTransformationSimulateIn;
EndpointTransformationSimulateIn.discriminator = undefined;
EndpointTransformationSimulateIn.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string",
        "format": ""
    },
    {
        "name": "eventType",
        "baseName": "eventType",
        "type": "string",
        "format": ""
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "any",
        "format": ""
    }
];
//# sourceMappingURL=EndpointTransformationSimulateIn.js.map